
import Button from '@/ui-kit/components/button';
import { StyleSizeType, StyleColorSchemeType, StylePositionType } from '@/ui-kit/styles/enums';
import { ButtonFillType } from '@/ui-kit/components/button/enums';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import Icon from '@/ui-kit/components/icon';
import { IconType } from '@/ui-kit/components/icon/enums';
import Gutter from '@/ui-kit/components/gutter';
import Container from '@/components/container';
import Content from '@/components/content';
import WheelIcon from '@/components/icons/wheel';
import RepresentorSelection from '@/components/page-specific/commission-calculator/representor-selection';
import { Representor } from '@/components/page-specific/commission-calculator/enums';
import {
  StartPrice,
  MinMaxPrice,
  ListSideCommissionRates,
} from '@/components/page-specific/buy-sell-your-home/commission-calculator-section/enums';
import { BuyerCommissionRatesByProvince } from '@/utils/commission/constants';
import { formatMoney } from '@/utils/utilities';
import CommissionHelper from '@/utils/commission';
import routes from '@/constants/routes';
import { PROVINCES } from '@/constants';
import { SliderEventType } from '../slider/enums';
import Table from '../table';
import Slider from '../slider';
import { COMMISSION_SLIDER_TITLE } from './constants';

export default {
  name: 'SellerComponent',
  components: {
    Container,
    Content,
    Typography,
    Slider,
    Table,
    WheelIcon,
    Button,
    Gutter,
    Icon,
    RepresentorSelection,
  },
  props: {
    slider: {
      type: Object,
      required: true,
      title: {
        type: Object,
        text: {
          type: String,
        },
        tip: {
          type: String,
        },
      },
      description: {
        type: Object,
        text: {
          type: String,
        },
        tip: {
          type: String,
        },
      },
    },
    commissions: {
      type: Object,
      required: true,
      title: {
        type: String,
      },
      reminder: {
        type: Object,
        title: {
          type: String,
        },
      },
    },
    agent: {
      type: Object,
      required: true,
      title: {
        type: String,
      },
    },
    result: {
      type: Object,
      required: true,
      legend: {
        type: Object,
        left: {
          type: String,
        },
        right: {
          type: String,
        },
      },
      tip: {
        type: String,
      },
    },
    tableDisclaimer: {
      type: Object,
      default: () => {},
    },
    activeProvince: {
      type: String,
      default: PROVINCES.AB,
    },
  },
  data() {
    return {
      currentProvince: this.activeProvince,
      price: {
        value: StartPrice[PROVINCES.AB],
        min: MinMaxPrice.MIN,
        max: MinMaxPrice.MAX,
      },
      rates: [...BuyerCommissionRatesByProvince[PROVINCES.AB]],
      commission: {
        min: 0,
        max: 20,
        ratio: 2,
      },
      remainder: {
        min: 0,
        max: 14,
        ratio: 2,
      },
      isAgentSelected: true,
      StyleSizeType,
      StyleColorSchemeType,
      StylePositionType,
      ButtonFillType,
      TypographyType,
      IconType,
      routes,
      Representor,
      StartPrice,
      MinMaxPrice,
      SliderEventType,
    };
  },
  computed: {
    commissionSliderTitle() {
      return COMMISSION_SLIDER_TITLE[this.activeProvince];
    },
    isMultiRateProvince() {
      const MINIMUM_RATE_LENGTH = 1;

      return BuyerCommissionRatesByProvince[this.activeProvince].length > MINIMUM_RATE_LENGTH;
    },
    costBodeSeller() {
      return CommissionHelper.getBodeCommission(this.price.value);
    },
    costBodeBuyer() {
      const { value } = this.price;

      if (this.isAgentSelected) {
        return this.fee(value);
      }

      return 0;
    },
    costAgentSeller() {
      const { value } = this.price;

      switch (this.activeProvince) {
        case PROVINCES.AB:
          return this.agentFee(value);
        case PROVINCES.BC:
          return this.bcListingAgentFee(value);
        case PROVINCES.ON:
          return this.ontarioAgentFee(value);
        default:
          break;
      }

      return '';
    },
    costAgentBuyer() {
      return this.agentFee(this.price.value);
    },
    savings() {
      const feeAgent = this.costAgentSeller + this.costAgentBuyer;
      const feeBode = this.costBodeSeller + this.costBodeBuyer;

      return Math.round(feeAgent - feeBode);
    },
    noteText() {
      return this.tableDisclaimer[this.activeProvince.toLowerCase()];
    },
    savingsLimitToZero() {
      const savings = Math.max(this.savings, 0);

      return this.format(savings);
    },
  },
  watch: {
    activeProvince(val) {
      this.currentProvince = val;
      this.onChangeProvince(val);
    },
  },
  mounted() {
    this.onChangeProvince(this.currentProvince);
  },
  methods: {
    setIsAgentSelected(selection) {
      this.isAgentSelected = selection !== Representor.Bode;
    },
    agentFee(price) {
      return CommissionHelper.getBuyerCommission(price, this.currentProvince);
    },
    fee(price) {
      return CommissionHelper.getCommissionByRate(this.rates, price);
    },
    bcListingAgentFee(price) {
      return CommissionHelper.getCommissionByRate(ListSideCommissionRates, price);
    },
    ontarioAgentFee(price) {
      return CommissionHelper.getSellerCommission(price, this.currentProvince);
    },
    setPrice(value) {
      this.price.value = value;
    },
    setCommission(value) {
      this.rates[0].value = value;
    },
    setRemainder(value) {
      this.rates[1].value = value;
    },
    format(nb) {
      return formatMoney(nb);
    },
    onChangeProvince(province) {
      this.setPrice(StartPrice[province]);
      this.rates = BuyerCommissionRatesByProvince[province];
      this.$emit('onChangeSellerProvince', this.currentProvince, this.price.value);
    },
    handleListYourHomeButtonClick() {
      this.$router.push(routes.listHome);
    },
  },
};
